export default __webpack_public_path__ + "static/media/vote.3da138a2.svg";